class MorrisQuantityPacks extends HTMLElement {
connectedCallback(){
 if(this.bound)return;this.bound=true;
 this.addEventListener('change',event=>{if(event.target.matches('input[type="radio"]'))this.setQuantity(Number(event.target.value));});
 this.scope=this.closest('.shopify-section');
 this.scope?.addEventListener('change',event=>{if(event.target.matches('input[name="quantity"]'))this.syncSelection(Number(event.target.value));});
 this.setQuantity(1);
}
setQuantity(qty){
 this.scope?.querySelectorAll('product-form-component').forEach(form=>{
 const id=form.querySelector('input[name="id"]');if(id)id.value=this.dataset.variantId;
 const selector=form.querySelector('quantity-selector-component');
 if(selector?.setValue)selector.setValue(qty);
 const input=form.querySelector('input[name="quantity"]');if(input){input.value=String(qty);input.dispatchEvent(new Event('change',{bubbles:true}));}
 form.dataset.quantityDefault=String(qty);
 });
 this.syncSelection(qty);
}
syncSelection(qty){
 this.querySelectorAll('input[type="radio"]').forEach(input=>input.checked=Number(input.value)===qty);
 const selected=this.querySelector('input:checked');
 const display=selected?.closest('label')?.querySelector('strong')?.textContent || new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:this.dataset.currency || 'USD'}).format(qty*Math.ceil(Number(this.dataset.basePrice)*(qty>=3?0.75:qty>=2?0.85:1))/100);
 if(display)this.scope?.querySelectorAll('product-price .price').forEach(el=>el.textContent=display);
 const bar=document.querySelector('[aria-label="Quick add to cart bar"]');
 if(bar && display){const price=bar.querySelector('.price');if(price)price.textContent=display;const title=bar.querySelector('[data-testid="sticky-variant-title"]');if(title)title.textContent=selected?.closest('label')?.querySelector('.mqp-name')?.textContent || `${qty} Morrises`;}

}
}
if(!customElements.get('morris-quantity-packs'))customElements.define('morris-quantity-packs',MorrisQuantityPacks);
